import React, { Component } from 'react';
import gif from "../images/dorothee.gif"

class secondPart extends Component {

  render() {
    return (
      <div id="concept" className="secondPart">
        <div className="container">
          <div className="left">
            <h3>La semaine a été difficile ?</h3>
            <p>
            Venez nous rejoindre à l’agence Bakasable tous les vendredis matins pour prendre un bon petit déjeuner et parler nouveauté.
            </p>
            <p>
            Nous sommes un peu comme un saut en parachute mêlé à un câlin, une sorte de frisson confortable, en bref la solution idéale pour une fin de semaine fatale !
            </p>
            <p>
            Le temps d’un matin, on vous accueille pour parler innovation, projets et numérique.
            Que demander de plus pour commencer la dernière journée de la semaine ? Le petit déj offert ? Eh oui, ça aussi on le fait.
            </p>
          </div>
          <div className="right">
            <img src={gif}/>
          </div>
        </div>
      </div>
    )
  }

}

export default secondPart;



// WEBPACK FOOTER //
// ./src/client/components/secondPart.js